var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VisualContainer } from "./VisualContainer";
import { Image } from "./Image";
export const Modal = (props) => {
    const { onClose } = props, rest = __rest(props, ["onClose"]);
    return _jsxs("div", { style: { position: 'absolute', top: '50%', left: '50%', translate: '-50% -50%', }, children: [_jsx("div", { style: { width: '2rem', height: '2rem', display: 'flex', position: 'absolute', left: 'calc(100% - 3rem)', top: '1rem', cursor: 'pointer', zIndex: 3 }, onClick: onClose, children: _jsx(Image, { style: { width: '1rem', height: '1rem', margin: 'auto' }, src: 'images/closeXBlue.png' }) }), _jsx(VisualContainer, Object.assign({}, rest, { style: Object.assign({ backdropFilter: `blur(${'10px'})`, WebkitBackdropFilter: `blur(${'10px'})` }, rest.style) }))] });
};
//# sourceMappingURL=Modal.js.map